'use client';

import { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import type { IconName } from '@/shared/ui/icon';
import './alert.scss';

export enum AlertType {
    SUCCESS = 'success',
    ERROR = 'error',
    ALERT = 'alert',
    INFO = 'info',
}

type Props = {
    type?: AlertType | `${AlertType}`;
    heading: ReactNode;
    description?: ReactNode;
    buttons?: ReactNode;
    onClose(): void;
    testIds?: {
        wrapper?: string;
        icon?: string;
        heading?: string;
        description?: string;
        closeBtn?: string;
    };
};
export const Alert = ({ type = AlertType.INFO, heading, description, buttons, testIds, onClose }: Props) => {
    const iconName: IconName =
        type === AlertType.SUCCESS ? 'check' : type === AlertType.INFO ? 'bell' : 'warning';

    return (
        <div className={cn('alert', type === 'error' && 'alert--error')} data-testid={testIds?.wrapper}>
            <div className="alert__avatar">
                <Icon name={iconName} className="alert__avatar-icon" />
            </div>
            <div className="alert__content">
                <p className="alert__heading" data-testid={testIds?.heading}>
                    {heading}
                </p>
                {description && (
                    <p className="alert__description" data-testid={testIds?.description}>
                        {description}
                    </p>
                )}
            </div>
            {buttons && <div className="alert__buttons-container">{buttons}</div>}
            <button
                onClick={onClose}
                className="alert__close-btn"
                data-testid={testIds?.closeBtn}
                aria-label="close"
            >
                <Icon name="close" className="alert__close-btn-icon" />
            </button>
        </div>
    );
};
